import {IntermediatePart} from "../../intermediatePart";

export default class Dishwasher extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'dishwasher';
    this.partName = 'Dishwasher';
    this.translateId = "visualizer.kitchen.appliance.dishwasher";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Dishwasher());
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Appliances.Dishwasher;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
